import { apiClient } from '../client';
import type { LiveCampaign, CampaignSurface } from '@/lib/campaigns/portalCampaigns';

export const messageCampaignFeedApi = {
  async live(
    surface: CampaignSurface = 'portal',
  ): Promise<{ data: LiveCampaign[]; error: string | null }> {
    try {
      const response = await apiClient.get<LiveCampaign[]>('/message-campaigns/live', {
        params: { surface },
      });
      if (response.error) return { data: [], error: response.error };
      return { data: Array.isArray(response.data) ? response.data : [], error: null };
    } catch (e: any) {
      return { data: [], error: e?.message || 'Failed to fetch campaigns' };
    }
  },

  async impression(id: string): Promise<{ error: string | null }> {
    try {
      const response = await apiClient.post(`/message-campaigns/${id}/impression`, {});
      return { error: response.error ?? null };
    } catch (e: any) {
      return { error: e?.message || 'Failed to record impression' };
    }
  },

  async click(id: string): Promise<{ error: string | null }> {
    try {
      const response = await apiClient.post(`/message-campaigns/${id}/click`, {});
      return { error: response.error ?? null };
    } catch (e: any) {
      return { error: e?.message || 'Failed to record click' };
    }
  },

  async videoPlay(id: string): Promise<{ error: string | null }> {
    try {
      const response = await apiClient.post(`/message-campaigns/${id}/video-play`, {});
      return { error: response.error ?? null };
    } catch (e: any) {
      return { error: e?.message || 'Failed to record video play' };
    }
  },

  async dismiss(id: string): Promise<{ error: string | null }> {
    try {
      const response = await apiClient.post(`/message-campaigns/${id}/dismiss`, {});
      return { error: response.error ?? null };
    } catch (e: any) {
      return { error: e?.message || 'Failed to dismiss campaign' };
    }
  },
};
